import App, { Container } from "next/app";
import withRedux from "next-redux-wrapper";
import React from "react";
import { Provider } from "react-redux";

import Layout from "../src/layout/Layout";
import { initStore } from "../src/store/configureStore";
import { Intercom } from "../src/intercom";
import { Toaster } from "react-hot-toast";
import getEnvVariable from "../src/helpers/env";
import { ClientSideLDProvider } from "../src/launchdarkly/ClientSideLDProvider";

export class Kairos extends App {
  static async getInitialProps({ Component, ctx }) {
    return {
      pageProps: Component.getInitialProps
        ? await Component.getInitialProps(ctx)
        : {},
    };
  }

  render() {
    const { Component, pageProps, store } = this.props;

    const ldClientId = getEnvVariable(
      "CHAUFFEUR_DOMAIN_LAUNCHDARKLY_CLIENT_SIDE_ID",
    );

    const AppContent = (
      <Provider store={store}>
        <Layout pageProps={pageProps}>
          <Component {...pageProps} />
          <Intercom appId={process.env.INTERCOM_APP_ID} />
          <Toaster />
        </Layout>
      </Provider>
    );

    // Always wrap with LaunchDarkly provider for consistent component tree
    // Provider handles null/undefined client ID gracefully
    return (
      <Container>
        <ClientSideLDProvider clientSideID={ldClientId}>
          {AppContent}
        </ClientSideLDProvider>
      </Container>
    );
  }
}

export default withRedux(initStore)(Kairos);
